import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { BaseEnumItemByIdPipe } from '@app/pipes/base-enum-item-by-id.pipe';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { StepsStore } from '@app/stores/project-setup/steps/steps.store';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { UploadFilesComponent } from '@app/ui-components/upload-files/upload-files.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { TranslateModule } from '@ngx-translate/core';
import { TitleNameCardComponent } from 'src/app/components/title-name-card/title-name-card.component';

@Component({
  selector: 'app-section-a',
  imports: [
    BaseEnumItemByIdPipe,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    CardComponent,
    ValidatedInputComponent,
    ValidatedNumberInputComponent,
    ValidatedDropdownComponent,
    ValidatedCheckboxComponent,
    ValidatedTextAreaComponent,
    TitleNameCardComponent,
    UploadFilesComponent,
    GetLocalizedPipe,
  ],
  templateUrl: './section-a.component.html',
  styleUrls: ['./section-a.component.scss'],
})
export class SectionAComponent implements OnInit {
  wizardStore = inject(WizardStore);
  stepsStore = inject(StepsStore);
  genericDataStore = inject(GenericStore);
  protected translationKey = 'projectWizard.sectionAForm.';
  projectId = input.required<string>();

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.A)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response) {
        }
      });
  }
}
